import "./sections.css"

import React, {
  Fragment,
  useEffect,
  useRef,
  useState,
} from "react"

import axios from "axios"

import { API_BASE_URL } from "../../constants/config"
import { defaultDog2 } from "../../constants/defaults"
import { getAge } from "../../constants/utility"
import Lightbox from "../lightbox"
import PhotoSlider from "../shared/photo-slider"

const DogFeeds = ({ type, per_page }) => {
    const [state, setState] = useState({ data: [], selected_data: null, total_page: 0, page: 1, busy: false });
    const [result, setResult] = useState([]);
    const lightboxRef = useRef();
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 8000
    }

    useEffect(() => {
        var m = true;
        if (m) {
            var config = {};
            config.params = { page: state.page, per_page: (per_page ? per_page : 20) };
            setState(state => ({ ...state, busy: true }))
            axios.get(API_BASE_URL + "/website/dogs/" + type, config).then(({ data }) => {
                ///  var new_data = data.data.data;


                setState((state) => ({ ...state, data: data.data.data, total_page: data.data.total_page, busy: false }));
            })
        }
        return () => {
            m = false;
        }
    }, [type, state.page])

    const getImage = (media) => {
        var arr = media.filter((item) => {
            return item.media_type === "image";
        })

        return arr[0];

    }


    useEffect(() => {

        var new_data = state.data;
        setResult((state) => ([...state, ...new_data]));

    }, [state.data])
    return <Fragment>

        <section className="dogfeed-sec1">
            <div className="content">

                <div className="items">
                    {result && result.map((item, key) => {
                        return <div key={key} className="item">
                            <button className="thumb" onClick={() => {
                                setState((state) => ({ ...state, selected_data: item }));
                                lightboxRef.current.show()
                            }}>
                                <span className={"status " + (item.status === "Available" ? "bg-orange-400" : "bg-brown")}>{item.status}</span>
                                <span className="view-more">View More</span>
                                {item.photos && item.photos.filter(item => (item.media_type === "image")).length > 0 && <img src={API_BASE_URL.replace("/v1", "/") + getImage(item.photos).path} alt={item.name ? item.name : ""} />}
                                {item.photos && item.photos.length === 0 && <img alt="default" src={defaultDog2} />}
                            </button>
                            <div className="text">

                                <button className="name">{item.name ? item.name : ""} <span>&mdash; {getAge(item.birthdate)} old {item.color ? item.color.name : ""} {item.gender}</span></button>
                            </div>
                        </div>
                    })}


                </div>
                {!state.busy && result && result.length === 0 && <div className="p-10 bg-gray-200 text-gray-500 flex flex-row justify-center items-center w-full">No dogs available</div>}
                {state.page < state.total_page && <button className="btn-accent mt-5" onClick={() => {
                    var n = state.page;
                    if (n < state.total_page) {

                        n++;
                        setState((state) => ({ ...state, page: n }))
                    }
                }}>More</button>}
            </div>

        </section>
        <Lightbox ref={lightboxRef} className="lightbox-dog">
            {state.selected_data && <div className="flex flex-col p-8 relative">
                <span className={"py-3 px-4 absolute left-0 top-0 text-white font-medium " + (state.selected_data.status === "Available" ? "bg-orange-400" : "bg-brown")}>{state.selected_data.status}</span>
                <h3 className="text-xl text-gray-700 mb-2 mt-10">{state.selected_data.name} <span className="text-gray-500">&mdash; {getAge(state.selected_data.birthdate)} old {state.selected_data ? state.selected_data.color.name : ""} {state.selected_data.gender}</span></h3>
                {state.selected_data.photos && state.selected_data.photos.length > 0 && <PhotoSlider photos={state.selected_data.photos} settings={settings} />}
                {state.selected_data.photos && state.selected_data.photos.length === 0 && <img className="mb-5" alt="default" src={defaultDog2} />}
                <div className="flex flex-col site-content" dangerouslySetInnerHTML={{ __html: state.selected_data.bio.story }}></div>
            </div>}
        </Lightbox>
    </Fragment>
}



export default DogFeeds;